import {createSlice} from "@reduxjs/toolkit";
import Nullable from "@/types/utils/Nullable";
import State from "@/types/utils/State";
import {IPreco, ITabelaVigente, Periodicidade} from "@/types/IOffer";
import { Interface } from "readline";

interface IValor{
    loading: boolean
    label: string
    periodo: string
    valor: number
    original: number
}

interface ITexto{
    legal: string
    acesso: string
}
export interface IParcelamentoOptions{
    value?: string
    texto?: string
    find?: any
    length?: any
    text?: string
}
export interface IPagamentoOptions{
    debito?: boolean
    credito?: boolean
}
export interface IOfferValue {
    loading: boolean
    loaded: boolean
    offer_type: Nullable<string>
    valor?: IValor
    texto?: ITexto
    is_escadinha?: boolean
    is_negative_option?: boolean
    name?: string
    brinde?: Nullable<string>
    parceiro_id?: string
    has_partner?: boolean
    escadinha?: any
    periodicidade?: Nullable<Periodicidade>
    preco_capa?: Nullable<IPreco>
    valor_demais?: Nullable<IPreco>
    tabela_vigente?: Nullable<ITabelaVigente>
    cd_oferta?: string
    forma_pagamento?: IPagamentoOptions
    id_transacao?: number
    is_cortesia?: boolean
    ztermCode?: string
    zterm?: IParcelamentoOptions
}

const initialState: State<IOfferValue> = {
    value: {
        loading: false,
        loaded: false,
        offer_type: null
    }
}

export const offerSlice = createSlice({
    name: "offer",
    initialState,
    reducers: {
        SET_OFFER: (state, action: {payload: IOfferValue}) => {
            const {payload} = action
            if (payload.cd_oferta !== 'UNDEFINED') {
                state.value.loaded = true;
            }
            state.value = payload
        },
        SET_OFFER_VALUE: (state, action: {payload: string}) => {
            const {payload} = action

            if(!state.value.valor){
                state.value.valor = {
                    loading: false,
                    label: '',
                    periodo: '',
                    valor: 0,
                    original: 0
                }
            }

            const numericValue = parseFloat(payload.replace(',', '.'))
            state.value.valor.loading = true
            state.value.valor.label = payload
            state.value.valor.periodo = '/mês'
            if (state.value.is_escadinha) {
                state.value.valor.original = numericValue
            } else {
                state.value.valor.valor = numericValue
            }
        },
    },
})

export const {SET_OFFER} = offerSlice.actions
export const {SET_OFFER_VALUE} = offerSlice.actions
export const GET_OFFER = (state: any): IOfferValue => state.offer.value
export const GET_OFFER_TYPE = (state: any): Nullable<string> => state.offer.value.offer_type
export const GET_OFFER_ZTERMCODE = (state: any): Nullable<string> => state.offer.ztermCode
export default offerSlice.reducer
